<div class="protocol-container">
  <div *ngIf="this.protocol" id="top">
    <h1>
      <div [innerHTML]="this.protocol.title"></div>
    </h1>
    <br />
    <div id="#generalinstructions">
      <h2><u>General Instructions</u></h2>
    </div>
    <div [innerHTML]="this.protocol.generalInstructions"></div>
    <br />
    <div id="#background">
      <h2><u>Background</u></h2>
    </div>
    <div [innerHTML]="this.protocol.background"></div>
    <br />
  
    <div *ngFor="let section of this.protocol.section">
      <div id="#section{{section.id}}">
        <h2><u>{{section.title}}</u></h2>
        <div [innerHTML]="section.descriptionHTML"></div>
      </div>
      <br />
      <div *ngIf="section.sectionColumn.length > 2">
        <div id="#column{{column.id}}" *ngFor="let column of section.sectionColumn">
          <b><u>{{column.title}}</u></b>
          <div [innerHTML]="column.descriptionHTML"></div>
          <br />
        </div>
      </div>
      <div *ngIf="section.sectionItem && section.sectionItem.length > 0">
        <div id="#item{{item.id}}" *ngFor="let item of section.sectionItem">
          <b><u>{{item.title}}</u></b>
          <div [innerHTML]="item.descriptionHTML"></div>
          <br />
        </div>
      </div>
    </div>
    <br />
    <div id="#appendix">
      <h2><u>Appendix</u></h2>
    </div>
    <div [innerHTML]="this.protocol.appendix"></div>
  </div>
</div>
